import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9.2 15.6"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.4 7.8 0 1.4 1.4 0l7.8 7.8-7.8 7.8L0 14.1z" />
  </svg>
);
const SvgCaretRight = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="caret-right" {...props} />;
export default SvgCaretRight;
